import IntlService from 'beebee-base/services/intl';

export default class Intl extends IntlService {}
